import { Footer1Props } from "../../props";
import Link from "next/link";

export const FooterVariant02 = (props: Footer1Props) => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="pb-12">
      <div className="h-[2px] w-4/5 bg-slate-400 mx-auto" />

      <div className="md:w-2/5 px-10 md:px-0 text-center md:text-inherit mx-auto flex prose-p:font-sans prose-p:text-base">
        <p className="mx-auto dark:text-stone-400 mt-12 mb-16">
          © {currentYear}{" "}
          {typeof props?.action?.text != "undefined" ? props?.action?.text : ""}
          . Todos os direitos reservados. Desenvolvido por{" "}
          <Link
            target="_blank"
            href="https://www.sync.com.br"
            rel="noreferrer"
            className="underline"
          >
            sync
          </Link>
        </p>
      </div>
    </footer>
  );
};
